module.exports = __webpack_public_path__ + "static/media/hero-slier-img-3.e3676ae0.webp";